<template>
  <h1>General Settings</h1>
</template>

<script>
export default {};
</script>

<style></style>
